import { render, staticRenderFns } from "./UserApiHistory.vue?vue&type=template&id=1c47b000&scoped=true&"
import script from "./UserApiHistory.vue?vue&type=script&lang=js&"
export * from "./UserApiHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserApiHistory.vue?vue&type=style&index=0&id=1c47b000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47b000",
  null
  
)

export default component.exports